'use strict';
var strings = require('dibs-strings-helper');
console.warn('strings.js is deprecated.  Use dibs-strings-helper instead');
module.exports = strings;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/strings.js
// module id = 2044
// module chunks = 64